var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 26,
    viewBox: "0 0 143 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.50853 25.5108L0.0195312 25.0218V1.32982L0.50853 0.84082H5.49653L5.98553 1.32982V15.3668H16.3655V1.32982L16.8545 0.84082H21.8425L22.3315 1.32982V25.0228L21.8425 25.5118H16.8535L16.3645 25.0228V15.9058H5.98453V25.0228L5.49553 25.5118L0.50853 25.5108Z",
    fill: "#807CE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1024 0.84082H53.1475L57.9665 10.0408L62.7855 0.84082H68.8015L69.2905 1.32982L60.9665 14.4738V25.0228L60.4445 25.5118H55.4904L55.0015 25.0228V14.4738L46.6475 1.32982L47.1024 0.84082Z",
    fill: "#807CE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7253 25.5108H72.1433L71.6543 25.0218V1.32982L72.1433 0.84082H82.7253C89.5503 0.84082 93.6453 6.03082 93.6453 13.1758C93.6453 20.3378 89.5003 25.5108 82.7253 25.5108ZM77.6193 20.8258H80.1133C84.2583 20.8258 87.6623 18.6348 87.6623 13.1758C87.6623 7.71682 84.1063 5.52583 80.1133 5.52583H77.6193V20.8258Z",
    fill: "#807CE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.752 13.1921C95.752 5.92911 99.8969 0.537109 107.413 0.537109C114.929 0.537109 119.074 5.89611 119.074 13.1921C119.074 20.4881 114.895 25.8141 107.413 25.8141C99.9309 25.8141 95.752 20.4211 95.752 13.1921ZM107.43 21.1291C110.83 21.1291 113.13 18.5171 113.13 13.1921C113.13 7.86711 110.99 5.22112 107.43 5.22112C103.87 5.22112 101.73 7.93411 101.73 13.1921C101.73 18.4501 103.874 21.1291 107.43 21.1291Z",
    fill: "#807CE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.575 25.0218L127.902 4.32882V25.0218L127.413 25.5108H122.459L121.937 25.0218V1.32982L122.459 0.84082H126.637L127.159 1.32982L137.034 22.3098V1.32982L137.523 0.84082H142.511L143 1.32982V25.0228L142.511 25.5118H138.062L137.573 25.0228L137.575 25.0218Z",
    fill: "#807CE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5142 15.3668L37.2142 8.23885L39.9442 15.3668H34.5142ZM34.3142 15.9058L30.8762 25.0218L30.3872 25.5108H25.2312L24.7422 25.0218L34.6002 1.22784L35.1562 0.839844H39.3352L39.8912 1.22784L49.7662 25.0218L49.2772 25.5108H44.1212L43.6322 25.0218L40.1442 15.9058H34.3142Z",
    fill: "#807CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.14a4451cd88b16f2e8ec60ebe756f475.svg";
export { ForwardRef as ReactComponent };